import { Component, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { deleteEvent } from 'src/app/constants';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {
  modalObject: any;
  loading: boolean = false;
  modalMessageText: any;
  cancelButtonText: any;
  okButtonText: any;
  clinicListSubscriber: any;
  showOkButton: any;
  showCancelButton: any;
  isCopyClinic:any;

  constructor(private activeModal: NgbActiveModal,
    private sharedService: SharedService) {}

  ngOnInit(): void {
    this.modalMessageText = this.modalObject.modalMessageText;
    this.okButtonText = this.modalObject.okButtonText;
    this.cancelButtonText = this.modalObject.cancelButtonText;
    this.showOkButton = this.modalObject.showOkButton;
    this.showCancelButton = this.modalObject.showCancelButton;
    this.isCopyClinic=this.modalObject?.isCopyClinic
  }

  deleteClinic() {
    this.deleteGroupClinic();
  }

  closeModal(eventString: string) {
    this.activeModal.close({event:eventString});
  }

  deleteGroupClinic() {
    this.loading = true;
    const relativePath: string = `groupclinic/DeleteGroupClinic`;
    const getParams = {
      entityId: this.modalObject.clinicId
    }
    this.clinicListSubscriber = this.sharedService.postRequest(relativePath, getParams).subscribe(response => {
      this.closeModal(deleteEvent);
      this.loading = false;
    },
      errorResponse => {
        console.log(errorResponse);
        this.loading = false;
      });
  }
}
